import {Component, Input, OnInit} from '@angular/core';
import {ExportRestService} from '../../shared/services/export/export-rest.service';
import {ConfirmationService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {GlobalMessagesService} from '../../shared/services/messages/global.messages.service';
import {SecurityService} from '../../shared/services/security/security.service';
import {User} from '../../shared/types/security/user';
import {DirectorySearchOptions} from '../../shared/types/wsdirectory/directory-search-options';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'wsd-exports',
  templateUrl: './exports.component.html',
  styleUrls: ['./exports.component.css']
})
export class ExportsComponent implements OnInit {

  @Input()
  filter: any;

  block: boolean = false;

  isLoggedUser: boolean = false;

  user: User = null;

  constructor(private exportService: ExportRestService,
              private confirmService: ConfirmationService,
              private translate: TranslateService,
              private globalMessageService: GlobalMessagesService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.securityService.isAuthenticated().subscribe(value => {
      this.isLoggedUser = value;
    });
    this.securityService.getLoggedUser().subscribe((user: User) => {
      this.user = user;
    });
  }

  export(type) {
    this.confirmService.confirm({
      header: this.translate.instant('WS_DIRECTORY.EXPORT.CONFIRM_HEADER'),
      message: this.translate.instant('WS_DIRECTORY.EXPORT.CONFIRM_MESSAGE'),
      accept: () => {
        this.block = true;
        this.exportService.export(type, this.getSearchOptions(0, this.filter)).subscribe(
          res => FileSaver.saveAs(res.blob, res.filename),
          this.error,
          this.unblock
        );
      }
    });
  }

  private getSearchOptions(page: number, filter: any): DirectorySearchOptions {
    const searchObj = {
      name: filter.who,
      where: filter.where,
      size: 10,
      page,
      sortBy: filter.sortBy
    };

    return {...searchObj, ...filter.filters};
  }

  isFilterActive() {
    return this.filter.who ||
      this.filter.where ||
      Object.keys(this.filter.filters).some(key => this.filter.filters[key].length > 0);
  }

  private unblock = () => this.block = false;

  private error = () => {
    this.block = false;
    this.globalMessageService.showErrorMessage('failed',
      this.translate.instant(' '));
  }
}


